function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.03107 1.02925C0.030905 1.29372 0.13229 1.55846 0.33482 1.75965L5.30622 6.70085C5.70736 7.09944 6.35474 7.09944 6.75587 6.70085L11.7273 1.75965C12.1302 1.35909 12.1325 0.707232 11.7323 0.303939C11.332 -0.099618 10.6807 -0.10184 10.2776 0.298857L6.03096 4.51957L1.78437 0.298857C1.38133 -0.10184 0.730025 -0.099618 0.329735 0.303939C0.13055 0.504612 0.03107 0.766995 0.03107 1.02925Z",
  fill: "#A8A8A8"
});

function SvgArrowQuestion({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEzIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4wMzEwNyAxLjAyOTI1QzAuMDMwOTA1IDEuMjkzNzIgMC4xMzIyOSAxLjU1ODQ2IDAuMzM0ODIgMS43NTk2NUw1LjMwNjIyIDYuNzAwODVDNS43MDczNiA3LjA5OTQ0IDYuMzU0NzQgNy4wOTk0NCA2Ljc1NTg3IDYuNzAwODVMMTEuNzI3MyAxLjc1OTY1QzEyLjEzMDIgMS4zNTkwOSAxMi4xMzI1IDAuNzA3MjMyIDExLjczMjMgMC4zMDM5MzlDMTEuMzMyIC0wLjA5OTYxOCAxMC42ODA3IC0wLjEwMTg0IDEwLjI3NzYgMC4yOTg4NTdMNi4wMzA5NiA0LjUxOTU3TDEuNzg0MzcgMC4yOTg4NTdDMS4zODEzMyAtMC4xMDE4NCAwLjczMDAyNSAtMC4wOTk2MTggMC4zMjk3MzUgMC4zMDM5MzlDMC4xMzA1NSAwLjUwNDYxMiAwLjAzMTA3IDAuNzY2OTk1IDAuMDMxMDcgMS4wMjkyNVoiIGZpbGw9IiNBOEE4QTgiLz4KPC9zdmc+Cg==";
export { SvgArrowQuestion as ReactComponent };